
import { EntityCreationConfig } from '../types';

// Entity configurations define research behavior for creation modals
export const ENTITY_CREATION_CONFIGS: Record<string, EntityCreationConfig> = {
  page: {
    entityType: 'page',
    researchLimit: 2,
    theme: 'purple',
    attachmentTable: 'workbook_page_research_attachments',
    attachmentColumn: 'page_content_id',
    displayName: 'Page',
    summarizationPrompt: 'page-context-summary'
  },
  
  workbook: {
    entityType: 'workbook', 
    researchLimit: 3,
    theme: 'purple',
    attachmentTable: 'workbook_research_attachments',
    attachmentColumn: 'workbook_id', // Changed from workbook_page_id to workbook_id
    displayName: 'Workbook',
    summarizationPrompt: 'workbook-context-summary'
  },
  
  // Future entity configurations (ready for expansion)
  project: {
    entityType: 'project',
    researchLimit: 5, 
    theme: 'green',
    attachmentTable: 'project_research_attachments',
    attachmentColumn: 'project_id',
    displayName: 'Project',
    summarizationPrompt: 'project-context-summary'
  },
  
  goal: {
    entityType: 'goal',
    researchLimit: 3,
    theme: 'orange', 
    attachmentTable: 'goal_research_attachments',
    attachmentColumn: 'goal_id',
    displayName: 'Goal',
    summarizationPrompt: 'goal-context-summary'
  },
  
  campaign: {
    entityType: 'campaign',
    researchLimit: 4,
    theme: 'red',
    attachmentTable: 'campaign_research_attachments', 
    attachmentColumn: 'campaign_id',
    displayName: 'Campaign',
    summarizationPrompt: 'campaign-context-summary'
  }
};

export const getEntityCreationConfig = (entityType: string): EntityCreationConfig => {
  const config = ENTITY_CREATION_CONFIGS[entityType];
  if (!config) {
    throw new Error(`No creation research configuration found for entity type: ${entityType}`);
  }
  return config;
};

export const getEntityDisplayName = (entityType: string): string => {
  return getEntityCreationConfig(entityType).displayName;
};

export const getEntityTheme = (entityType: string): EntityCreationConfig['theme'] => {
  return getEntityCreationConfig(entityType).theme;
};

export const getEntityResearchLimit = (entityType: string): number => {
  return getEntityCreationConfig(entityType).researchLimit;
}; 
